import styled from "styled-components";

export const CellTimeStyled = styled.span`
  margin-right: 8px;
`